import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { IconInstagram } from "@/components/icons";
import IconTelegram from "@/components/icons/IconTelegram.tsx";

const ContactsInformation = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <address className={"max-w-[20.3125rem] space-y-[1.875rem] max-lg:space-y-4"}>
      <div className={"max-lg:text-bases text-lg/6"}>
        <p className={"text-grey-1"}>E-mail:</p>
        <a href="mailto:support@sevimliplay.tv" className={"max-lg:font-medium"}>
          support@sevimliplay.tv
        </a>
      </div>
      <div className={"max-lg:text-bases text-lg/6"}>
        <p className={"text-grey-1"}>Telegram bot:</p>
        <a href="https://t.me/splaysupport_bot" target={"_blank"} rel={"nofollow"} className={"max-lg:font-medium"}>
          splaysupport_bot
        </a>
      </div>
      <div className={"max-lg:text-bases text-lg/6"}>
        <p className={"text-grey-1"}>{t("Contacts.address")}:</p>
        <a href={"https://yandex.uz/maps/-/CDD4rC3T"} target={"_blank"} className={"max-lg:font-medium"}>
          {t("Contacts.address-description")}
        </a>
      </div>
      <div>
        <p className={"text-lg/6 text-grey-1 max-lg:text-base/6"}>{t("Contacts.our-social")}</p>
        <div className={"mt-2.5 flex gap-4"}>
          <a
            href={"https://www.instagram.com/splay.uz/"}
            target={"_blank"}
            rel={"nofollow"}
            className={
              "block rounded-full bg-surface-container p-[0.625rem] transition-colors hover:bg-surface-container-high"
            }
          >
            <IconInstagram className={"size-6 fill-on-primary"} />
          </a>{" "}
          <a
            href={"https://t.me/Splayuz"}
            target={"_blank"}
            rel={"nofollow"}
            className={
              "block rounded-full bg-surface-container p-[0.625rem] transition-colors hover:bg-surface-container-high"
            }
          >
            <IconTelegram className={"size-6 fill-on-primary"} />
          </a>
        </div>
      </div>
    </address>
  );
};

export default ContactsInformation;
